var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('v-layout',{staticClass:"d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"200"}})],1):_c('survey-public',{attrs:{"surveyData":_vm.surveyData,"reviewData":_vm.reviewResponseData}})
}
var staticRenderFns = []

export { render, staticRenderFns }